<template>
  <BaseModal
    class="eventmap-poi-modal"
    :title="modalTitle"
    ref="modal"
    width="wide"
    height="tall"
    startOpen
  >
    <div class="base-modal__body-row">
      <p v-if="eventmapPoi.description" class="eventmap-poi-modal__description">
        {{ eventmapPoi.description }}
      </p>
      <section class="carousel__section">
        <div class="carousel__row">
          <FeCarousel v-if="eventmapPoi.gallery && eventmapPoi.gallery.length" :autoplay-duration="5">
            <template v-for="(image, index) in eventmapPoi.gallery" :key="index">
              <div class="carousel-card eventmap-poi-modal__carousel-card">
                <img
                  class="carousel-card__image"
                  :src="image.src"
                  :alt="image.alt || 'Gallery Image'"
                />
              </div>
            </template>
          </FeCarousel>
        </div>
      </section>
    </div>
  </BaseModal>
</template>

<script>
import axios from 'axios';
import FeCarousel from '~/Components/Frontend/FeCarousel.vue';
import { store } from '../../../Frontend/store';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      eventmapPoi: {},
      loading: true,
      errored: false,
    };
  },
  components: { FeCarousel },
  computed: {
    eventEdition() {
      return store.eventEdition;
    },
    modalTitle() {
      return this.loading || !this.eventmapPoi?.name ? '...' : this.eventmapPoi.name;
    },
    endpoint() {
      if (window.location.pathname.includes('/iframe/eventmap/')) {
        return `/${this.eventEdition.slug}/iframe/eventmap/poi/${this.id}`;
      }
      return `/${this.eventEdition.slug}/eventmap-poi/${this.id}`;
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      };
      axios
        .get(this.endpoint, config)
        .then((response) => {
          this.eventmapPoi = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(() => {
          this.errored = true;
        });
    },
    modalClose() {
      this.$refs.modal.close();
    },
  },
};
</script>
<style scoped>
.eventmap-poi-modal__description {
  font-size: var(--font-small);
  color: var(--ui-grey-600);
  margin-bottom: var(--sizing-6);
}
.eventmap-poi-modal__carousel-card {
  grid-template-columns: 1fr;
}
</style>
